import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchQuestionStart,
  resetIsFetchingQuestion,
  resetQuestion,
} from "../../redux/questions/reducer";
import {
  selectIsFetchingQuestion,
  selectQuestion,
} from "../../redux/questions/selectors";

const useSingleQuestionGet = ({ id }) => {
  const dispatch = useDispatch();
  const loadingQuestion = useSelector(selectIsFetchingQuestion);
  const question = useSelector(selectQuestion);

  const getQuestion = useCallback(() => {
    if (!id) return;
    dispatch(fetchQuestionStart({ id }));
  }, [dispatch, id]);

  const resetQuestionLoading = () => {
    dispatch(resetIsFetchingQuestion());
  };

  const reset = () => {
    resetQuestionLoading();
    dispatch(resetQuestion());
  };

  return {
    getQuestion,
    loadingQuestion,
    question,
    resetQuestionLoading,
    reset,
  };
};

export default useSingleQuestionGet;
